<template>
  <div>
  <table>
    <tr class="regular-16 text-center text-muted" v-if="visits.length < 1">
      <td>No Visits Found</td>
    </tr>
    <div v-for="(visit, i) in visits" :key="i" class="mb-2" v-else>
      <tr>
        <td><div class="text-muted regular-16">Visit Date</div></td>
        <td><div class="text-muted regular-16">:</div></td>
        <td>
          <div class="regular-16 ml-2">
            {{visit.estimated_arrival_date ? moment(visit.estimated_arrival_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') : '--'}} -
            {{visit.estimated_departure_date ? moment(visit.estimated_departure_date, 'YYYY-MM-DD').format('MMMM Do, YYYY') : '--'}}
            <a :href="fetchLegacyUrl(`/${pageTo}/${member.program_id}/members/${member.member_id}/visits/${visit.id}/edit`)">
              <i class="fa fa-edit custom-fa-edit-color" v-b-tooltip.hover.top title="Edit" />
            </a>
          </div>
        </td>
      </tr>
      <tr>
        <td><div class="text-muted regular-16">Office No</div></td>
        <td><div class="text-muted regular-16">:</div></td>
        <td>
          <div class="regular-16 ml-2">
            {{visit.office_no ? visit.office_no : '--'}}
          </div>
        </td>
      </tr>
      <tr>
        <td><div class="text-muted regular-16">Office Phone No</div></td>
        <td><div class="text-muted regular-16">:</div></td>
        <td>
          <div class="regular-16 ml-2">
            {{visit.office_phone_no ? visit.office_phone_no : '--'}}
          </div>
        </td>
      </tr>
      <tr v-if="member.sign_in_access">
        <td><div class="text-muted regular-16">Sign In</div></td>
        <td><div class="text-muted regular-16">:</div></td>
        <td>
          <div>
            <span class="regular-16 ml-2" v-if="visit.sign_in_date">
              {{moment(visit.sign_in_date, 'YYYY-MM-DD').format('MMMM Do, YYYY')}}
            </span>
            <span class="ml-2">
              <span v-if="!visit.sign_in_date && !visit.sign_out_date">
                <a :href="fetchLegacyUrl(`/${pageTo}/${member.program_id}/members/${member.member_id}/visits/${visit.id}/signins`)">
                  <i v-b-tooltip.hover ="'Sign In'" class="fas fa-sign-in-alt cursor-pointer typo-color-blue" />
                </a>
              </span>
              <span v-if="visit.sign_in_date">
                <a :href="fetchLegacyUrl(`/${pageTo}/${member.program_id}/members/${member.member_id}/visits/${visit.id}/signins`)">
                  <i v-b-tooltip.hover ="'Partial Sign In'" class='fas fa-user-edit cursor-pointer typo-color-blue' />
                </a>
              </span>
            </span>
          </div>
        </td>
      </tr>
      <tr v-if="member.sign_in_access">
        <td><div class="text-muted regular-16">Sign Out</div></td>
        <td><div class="text-muted regular-16">:</div></td>
        <td>
          <div class="ml-2" v-if="visit.sign_in_date && member.sign_in_access">
            <div class="regular-16" v-if="visit.sign_out_date">
              {{moment(visit.sign_out_date, 'YYYY-MM-DD').format('MMMM Do, YYYY')}}
            </div>
            <div v-else>
              <a :href="fetchLegacyUrl(`/${pageTo}/${member.program_id}/members/${member.member_id}/visits/${visit.id}/signouts`)">
                <i v-b-tooltip.hover ="'Sign Out'" class="fas fa-sign-out-alt cursor-pointer typo-color-black"/>
              </a>
            </div>
          </div>
          <div class="regular-16 ml-2" v-else>--</div>
        </td>
      </tr>
      <!-- <tr v-if="member.sign_in_access && member.exit_survey_notification_eligible">
        <td>
          <b-btn
            type="submit"
            class="btn btn-primary btn-sm mt-1"
            :disabled="buttonLoading"
            @click="getExitSurveyReminderEmail(visit.id)"
          >
            <b-spinner v-if="buttonLoading" />
            Exit survey reminder
          </b-btn>
        </td>
      </tr> -->
    </div>
  </table>
</div>
</template>

<script>
import mixin from "@/utils/mixin.js"

export default {
	name: "MemberVisitDetailSection",
	mixins: [mixin],
	props: ["member", "visits", "pageTo"],
	data() {
		return {
			buttonLoading: false,
		}
	},
	methods: {
		getExitSurveyReminderEmail(visitId) {
			this.buttonLoading = true
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/programs/exit_survey_notify`, {
					params: {
						program_visit: visitId,
					},
				})
				.then((res) => {
					if (res !== undefined) {
						this.$toasted.global.success("Exit survey reminder sent successfully")
						this.buttonLoading = false
					} else {
						//this.$toasted.global.error('Something went wrong, please try again.')
						this.buttonLoading = false
					}
				})
		},
	},
}
</script>

